import { Application } from '@hotwired/stimulus'

const adminStimulus = Application.start()

adminStimulus.debug = false

export { adminStimulus }